import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GoodTypes } from '../../operation/operationsInterface';
import { LoanSimulation } from '../eDniModalInterface';

interface ProductData {
  data: GoodTypes | null;
}

const initialState: ProductData = {
  data: null,
};

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    saveProduct: (state, action: PayloadAction<GoodTypes>) => {
      state.data = action.payload;
    },
  },
});

export const { saveProduct } = productSlice.actions;

export default productSlice.reducer;
